import templateUrl from './employee-work-order-product-orders-modal.component.html'

export const EmployeeWorkOrderProductOrdersModalComponent = {
    controller: EmployeeWorkOrderProductOrdersModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
}

function EmployeeWorkOrderProductOrdersModalController() {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;

    function onInit() {
        vm.workOrder = vm.resolve.workOrder;
        vm.onDismiss = function () {
            vm.dismiss({ $value: 'cancel' });
        };
    }

}
